// Browse & Choose "Selected" list: every active saved meal of the day (planned
// and logged) plus whatever the user adds in this visit, keyed by plan_id so
// two saved entries of the same recipe stay two separate rows. Pure helpers
// (no I/O). Adapted from integration/build43-logfood.
//
// pending / legacy `planned` rows are listed as Planned (removable here);
// completed rows are listed as Logged (locked here). Skipped, replaced and any
// other status are not part of the saved day and are never listed.

var LISTED_STATUSES = { pending: true, planned: true, completed: true };
var MEAL_TYPE_ORDER = { breakfast: 0, lunch: 1, dinner: 2, snack: 3 };

export function isLoggedEntry(entry) {
  return !!entry && entry.status === 'completed';
}

// One Selected entry from a saved /meal-plans/daily row. `macros` is the
// row's own saved contribution to the day (scaled, edited, leftover portion).
export function selectedEntryFromRow(row, date) {
  return {
    planId: row.plan_id,
    mealId: row.meal_id,
    name: row.meal_name || row.name || 'Meal',
    mealType: row.meal_type,
    date: row.date || date,
    status: row.status,
    imageUrl: row.image_url || null,
    macros: row.macros || null,
    leftoverRole: row.leftover_role || null,
    leftoverGroupId: row.leftover_group_id || null,
  };
}

// { plan_id: entry } for the day's pending / planned / completed rows.
export function selectedFromDailyPlan(rows, date) {
  var out = {};
  (Array.isArray(rows) ? rows : []).forEach(function (row) {
    if (row && row.plan_id && LISTED_STATUSES[row.status] && (!row.date || row.date === date)) {
      out[row.plan_id] = selectedEntryFromRow(row, date);
    }
  });
  return out;
}

export function selectionForDate(selection, date) {
  var out = {};
  Object.keys(selection || {}).forEach(function (pid) {
    if (selection[pid] && selection[pid].date === date) out[pid] = selection[pid];
  });
  return out;
}

export function addSelected(current, entry) {
  if (!entry || !entry.planId) return current;
  var next = Object.assign({}, current);
  next[entry.planId] = entry;
  return next;
}

// A successful delete proves only the clicked row was removed. The caller
// refreshes saved state to discover any conditional partner cascade.
export function removeSelected(current, entry) {
  var next = Object.assign({}, current);
  if (entry) delete next[entry.planId];
  return next;
}

// Entries in day order (Breakfast, Lunch, Dinner, Snack); stable otherwise.
export function orderedSelection(current) {
  return Object.keys(current || {}).map(function (pid) { return current[pid]; })
    .map(function (e, i) { return { e: e, i: i }; })
    .sort(function (a, b) {
      var ra = MEAL_TYPE_ORDER[String(a.e.mealType || '').toLowerCase()];
      var rb = MEAL_TYPE_ORDER[String(b.e.mealType || '').toLowerCase()];
      ra = ra === undefined ? 9 : ra;
      rb = rb === undefined ? 9 : rb;
      return ra - rb || a.i - b.i;
    })
    .map(function (x) { return x.e; });
}

// { meal_id: true } for the card "Added" state.
export function addedMealIds(current) {
  var ids = {};
  Object.keys(current || {}).forEach(function (pid) {
    var e = current[pid];
    if (e && e.mealId) ids[e.mealId] = true;
  });
  return ids;
}
